export class SessionConstants {
    public static readonly accessToken = 'accessToken';
    public static readonly blogDetails = 'blogDetails';
    public static readonly serviceDetails = 'serviceDetails';
    public static readonly careersDetails = 'careersDetails';
}
